<template>
    <div class="comparator">
        <div class="comparator-wrap">
            <div class="comparator-header">
                <img :src="resumeData.modelImg" alt="">
                <p class="h2"> {{ pipData(resumeData.modelid, 'title') }} </p>
                <p> {{ pipData(resumeData.modelid, 'content') }} </p>
            </div>
            <div v-if="!isMobile && false" class="comparator-items static">
                <ConfigCard v-for="(item, i) in cardData" :key="i"
                :checkboxField="type + i"
                :checkboxLabel="handleTitles(item)"
                :carSpecs="[item.fuel, item.transmission]"
                :carPrice="item.price"
                :checkBoxChecked="i === 0 && true"
                :carID="item.id"
                :disabled="maxCompareItems(i)"
                :value.sync="currID" />
            </div>
            <ComparatorItemsSwiper :cards="cardData" :currItems="items" :maxCI="maxCompared" :carID.sync="currID" :isMotor="isMotor"/>
        </div>
        <div class="comparator-content">
            <div class="comparator-content-header">
                <p v-html="comparatorMsg"></p>
                <CheckBox v-show="showToggleBtn" fieldClass="onOffType" fieldLabel="Ver diferenças" field="compareV"
                @checked-item="handleCurrListToRender($event)"
                :isChecked="listType" />
            </div>
            <div class="comparator-content-comparator">
                <div class="comparator-content-comparator-wrap">
                    <div class="lstItem">
                        <p></p>
                        <p v-for="(mvEl, i) in items" :key="i" class="header">{{ handleItemsTitles(mvEl) }}</p>
                    </div>

                    <div v-for="(item, j) in lstLabels" :key="j">
                        <p class="lstTitle">{{ isMotor ? item.title : item.name}}</p>
                        <div class="lst">
                            <div v-for="(el, k) in defineRenderList(item)" :key="k" class="lstItem">
                                <p>{{ el.name }}</p>
                                <p v-for="(elID, m) in items" :key="m" v-html="campareItems(el, elID, el.id)" ></p>
                            </div>
                        </div>
                    </div>

                    <div class="lstItem">
                        <span></span>
                        <button class="btn-primary" v-for="(id, l) in items" :key="l" @click="changeRoute(id)"> {{ setBtnText }} </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex';
    import ConfigCard from '../../Cards/ConfigCard/ConfigCard.vue'
    import CheckBox from '../../FormFields/CheckBox/CheckBox.vue'
    import ComparatorItemsSwiper from '../SwiperConts/ComparatorItemsSwiper.vue'

    export default {
        name: 'ComparatorBody',
        components:{ ConfigCard,  CheckBox , ComparatorItemsSwiper },
        props:{
            isMobile: {type: Boolean},
            cardData: {type: Array, default: () => { return []; }},
            type: {type: String},
        },
        inject: ['page'],
        data(){return{
            isMotor: true,
            btnText: ['Escolher', 'Selecionar '],
            currID: -1,
            items: [],
            comparatorMsg: '<b>Comparar</b> (selecione no minimo 2 versões)',
            maxCompared: 2,
            lstLabels: [],
            listType: false,
            failedEquips: [],
        }},
        mounted(){
            let isMotor = (this.type == 'Motor') ? true : false
            // this.items.push(this.cardData[0].id)

            if(isMotor) this.handleMotors()
            else this.handleVersions()


            let selectedID = isMotor ? this.resumeData.selectedEngine : this.resumeData.versionID
            let starter = this.cardData.find(el => el.id === selectedID)
            this.items.push(starter?.id)
            this.isMotor = isMotor
        },
        watch:{
            items: function(val){
                let vL = val.length;
                let max = this.maxCompared;

                if(vL < max)  this.comparatorMsg = '<b>Comparar</b> (selecione no minimo 2 versões)';
                if(vL >= max) this.comparatorMsg = '<b>Comparar</b> (no maximo 3 versões)';
            },
            currID: function(val){
                let id = val.id
                let currState = val.state
                let contains = this.items.some(el => el == id)
                let index = contains ? this.items.indexOf(id) : -1

                this.failedEquips = [];
                this.listType = false;

                if(currState){
                    (contains == false) && this.items.push(id)
                }else{
                    (contains) && this.items.splice(index, 1)
                }
            },
            listType: function(){
                if(!this.isMotor) this.handleVersions()
            }
        },
        computed:{
            ...mapState(['resumeData']),
            ...mapGetters({
                getEquipment: 'versionsData/getModelEquips',
                pipData: 'getPipContent',
            }),
            setBtnText(){
                let btnText = this.btnText;
                let str = '';
                if(this.type == 'Motor'){
                    str = (this.isMobile) ? btnText[0] : btnText[1] + 'motor';
                }else{
                    str = this.isMobile ? btnText[0] : btnText[1] + 'versão';
                }
                return str;
            },
            showToggleBtn(){
                let x = this.cardData.filter(el => this.items.includes(el.id))
                if(x.length > 1){
                    let state = false;
                    x.forEach(el => {
                        this.failedEquips.forEach(id => {
                            if(el.lst.includes(id))state = true
                        })
                    })
                    return state
                }
                return (this.items.length > 1 && !this.isMotor && this.failedEquips.length != 0) ? true : false
            },
        },
        methods:{
            handleItemsTitles(id){
                let obj = this.cardData.find(el => el.id == id)
                return this.handleTitles(obj)
            },
            maxCompareItems(id){
                if(this.items.length > this.maxCompared){
                    return (this.items.includes(id)) ? false : true;
                }
            },
            campareItems(lstEl, id, equipID){
                let checkSVG = '<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.2187 1.31315C20.4214 1.11102 20.6627 0.949842 20.9291 0.838826C21.1955 0.727811 21.4817 0.669131 21.7713 0.666136C22.0609 0.663142 22.3482 0.715891 22.617 0.821373C22.8857 0.926855 23.1305 1.083 23.3375 1.2809C23.5444 1.4788 23.7094 1.71458 23.8231 1.97477C23.9367 2.23496 23.9968 2.51447 23.9999 2.79733C24.0029 3.0802 23.9489 3.36089 23.8409 3.62337C23.733 3.88585 23.5731 4.12499 23.3705 4.32712L11.6445 18.6449C11.443 18.857 11.1997 19.0271 10.9293 19.1453C10.6588 19.2634 10.3668 19.327 10.0706 19.3323C9.77442 19.3377 9.48017 19.2846 9.20546 19.1763C8.93075 19.068 8.68122 18.9067 8.47179 18.7021L0.696013 11.1115C0.480643 10.9142 0.308073 10.6766 0.188556 10.4129C0.0690385 10.1492 0.00501275 9.86467 0.000282729 9.5763C-0.0044473 9.28793 0.0502153 9.00157 0.161022 8.73425C0.271828 8.46692 0.436518 8.22407 0.645306 8.02014C0.854094 7.8162 1.10272 7.65534 1.37641 7.54711C1.6501 7.43888 1.94327 7.38549 2.23851 7.39011C2.53374 7.39473 2.82501 7.45726 3.09501 7.574C3.36501 7.69074 3.60823 7.8593 3.81022 8.06966L9.96361 14.08L20.1692 1.38499C20.1874 1.3628 20.2069 1.34174 20.2278 1.32195L20.2187 1.31315Z" fill="#43A047"/></svg>';
                let failSVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.74304 1.03157C2.62803 0.915736 2.49147 0.823835 2.34117 0.761114C2.19086 0.698392 2.02976 0.666078 1.86704 0.666016C1.70433 0.665954 1.5432 0.698146 1.39285 0.760753C1.2425 0.82336 1.10587 0.915156 0.990775 1.0309C0.875677 1.14665 0.784358 1.28407 0.722034 1.43533C0.65971 1.5866 0.6276 1.74873 0.627539 1.91248C0.627415 2.24319 0.757837 2.5604 0.990113 2.79433L8.14491 9.99474L0.990113 17.1951C0.874666 17.3109 0.783003 17.4484 0.720357 17.5998C0.657711 17.7512 0.62531 17.9135 0.625002 18.0775C0.624695 18.2415 0.656487 18.404 0.718565 18.5556C0.780642 18.7072 0.871789 18.8451 0.986801 18.9612C1.21908 19.1959 1.53446 19.3281 1.86357 19.3287C2.02653 19.329 2.18795 19.297 2.33863 19.2345C2.4893 19.172 2.62627 19.0803 2.74171 18.9646L9.89651 11.7642L17.0513 18.9646C17.2834 19.1994 17.5987 19.3318 17.9278 19.3327C18.2569 19.3336 18.5729 19.2028 18.8062 18.9692C19.0396 18.7357 19.1711 18.4184 19.172 18.0872C19.1729 17.756 19.043 17.438 18.8109 17.2031L11.6561 10.0027L18.8109 2.80233C18.926 2.6865 19.0173 2.54899 19.0795 2.39765C19.1418 2.2463 19.1739 2.0841 19.1739 1.92028C19.1739 1.75647 19.1418 1.59427 19.0795 1.44292C19.0173 1.29158 18.926 1.15407 18.8109 1.03824C18.6958 0.922403 18.5591 0.830519 18.4087 0.767831C18.2584 0.705143 18.0972 0.672878 17.9344 0.672878C17.7716 0.672878 17.6104 0.705143 17.4601 0.767831C17.3097 0.830519 17.173 0.922403 17.0579 1.03824L9.90314 8.23864L2.74834 1.03824L2.74304 1.03157Z" fill="#FF0000" stroke="#FF0000" stroke-width="0.8"/></svg>';

                if(this.isMotor){
                    let currMotor = this.cardData.find(el => el.id == id)
                    let _res = currMotor.lst.find(el => el.id == lstEl.id)
                    return  _res != undefined ?  _res.specs.value : failSVG;
                }

                let currVersion = this.cardData.find(el => el.id == id)
                let res = currVersion.lst.includes(equipID)

                if(res) return checkSVG
                if(!this.failedEquips.includes(equipID)) this.failedEquips.push(equipID)
                return failSVG
            },
            handleTitles(item){
                if(this.isMotor){
                    if(item.power != 0) return item.engine + ' (' + item.power + ' CV)'
                    if(item.powerKw != 0) return item.engine + ' (' + item.powerKw + ' Kw)'
                    return item.engine
                }
                return item.designation.replace(item.engine, '')
            },
            handleMotors(){
                let motorData = [];
                this.cardData.forEach(el => motorData.push(el.lst))

                let motorUniqueLst = motorData.reduce((unique, o) => {
                    if(!unique.some(obj => obj.id === o.id)) unique.push(o);
                    return unique;
                });

                this.lstLabels = this.setEngineLstArr(motorUniqueLst)
            },
            setEngineLstArr(paramArr){
                let motor = []
                let perfAmb = []
                Object.entries(paramArr).filter((el, key) => {
                    if(key == 0 || key == 1) return
                    if(el[1].idType == 1) motor.push(el[1])
                    if(el[1].idType == 26) perfAmb.push(el[1])
                });

                let _array = [
                    { title : 'Motor', details : motor },
                    { title : 'Performance ambiental', details : perfAmb },
                ];
                return _array;
            },
            defineRenderList(item){
                if(this.isMotor ) return item.details
                return item.specs
            },
            handleCurrListToRender(e){ //switch between list
                this.listType = e
            },
            handleVersions(){
                let versionsData = [];
                this.cardData.forEach(el => versionsData = [...versionsData, ...el.lst])
                let fullLstIds = [...new Set(versionsData)]

                let list = this.listType ? this.failedEquips : fullLstIds
                this.lstLabels = this.getEquipment(list, true)
            },
            changeRoute(id){
                if(this.isMotor){
                    this.$router.push({name: 'Motors', params: { modelCompared: id }});
                    return
                }

                this.$router.push({name: 'Version', params: { versionCompared: id }});
            }
        },
    }
</script>
<style lang="scss">
    @import './ComparatorBody.scss';
</style>
